import { GET_RELEASE_NOTES, GET_LATEST_RELEASE_NOTE } from 'modules/dashboard/store/constants';

export const getReleaseNotes = () => ({
  type: GET_RELEASE_NOTES,
});

export const getLatestReleaseNotes = () => ({
  type: GET_LATEST_RELEASE_NOTE,
});
